var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconArrowBack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.0256231,0.346010228 C13.6095796,-0.115336743 12.9171435,-0.115336743 12.486553,0.346010228 C12.0705094,0.791771152 12.0705094,1.53366696 12.486553,1.97838881 L20.290521,10.3397831 L1.07744606,10.3397831 C0.47714083,10.3408222 0,10.8520445 0,11.4952287 C0,12.1384129 0.47714083,12.6662603 1.07744606,12.6662603 L20.290521,12.6662603 L12.486553,21.0120685 C12.0705094,21.4734155 12.0705094,22.2163504 12.486553,22.6610722 C12.9171435,23.1224192 13.6105494,23.1224192 14.0256231,22.6610722 L23.6770571,12.3202501 C24.1076476,11.8744891 24.1076476,11.1325933 23.6770571,10.6878715 L14.0256231,0.346010228 Z",
    transform: "matrix(-1 0 0 1 24 0)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowBack);
export default __webpack_public_path__ + "static/media/icon-arrow-back.cbfdffcb92b7ed6e0c16a766408ad463.svg";
export { ForwardRef as ReactComponent };